import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
	icon: LucideIcon;
	title: string;
	subtitle: string;
	className?: string;
}

export function EmptyState({
	icon: Icon,
	title,
	subtitle,
	className = "",
}: EmptyStateProps) {
	return (
		<div
			className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-base-content/20 bg-base-100/50 px-6 py-16 ${className}`}
		>
			<div className="flex size-16 items-center justify-center rounded-full bg-primary/10">
				<Icon className="size-8 text-primary" />
			</div>
			<h3 className="mt-4 text-lg font-semibold text-base-content">{title}</h3>
			<p className="mt-2 max-w-sm text-center text-sm text-base-content/60">
				{subtitle}
			</p>
		</div>
	);
}
